import _classCallCheck from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { PostgrestQueryBuilder } from '@supabase/postgrest-js';
import { SupabaseRealtimeClient } from './SupabaseRealtimeClient';
export var SupabaseQueryBuilder = /*#__PURE__*/function (_PostgrestQueryBuilde) {
  _inherits(SupabaseQueryBuilder, _PostgrestQueryBuilde);

  var _super = _createSuper(SupabaseQueryBuilder);

  function SupabaseQueryBuilder(url, _ref) {
    var _this;

    var _ref$headers = _ref.headers,
        headers = _ref$headers === void 0 ? {} : _ref$headers,
        schema = _ref.schema,
        realtime = _ref.realtime,
        table = _ref.table,
        fetch = _ref.fetch,
        shouldThrowOnError = _ref.shouldThrowOnError;

    _classCallCheck(this, SupabaseQueryBuilder);

    _this = _super.call(this, url, {
      headers: headers,
      schema: schema,
      fetch: fetch,
      shouldThrowOnError: shouldThrowOnError
    });
    _this._subscription = null;
    _this._realtime = realtime;
    _this._headers = headers;
    _this._schema = schema;
    _this._table = table;
    return _this;
  }
  /**
   * Subscribe to realtime changes in your database.
   * @param event The database event which you would like to receive updates for, or you can use the special wildcard `*` to listen to all changes.
   * @param callback A callback that will handle the payload that is sent whenever your database changes.
   */


  _createClass(SupabaseQueryBuilder, [{
    key: "on",
    value: function on(event, callback) {
      if (!this._realtime.isConnected()) {
        this._realtime.connect();
      }

      if (!this._subscription) {
        this._subscription = new SupabaseRealtimeClient(this._realtime, this._headers, this._schema, this._table);
      }

      return this._subscription.on(event, callback);
    }
  }]);

  return SupabaseQueryBuilder;
}(PostgrestQueryBuilder);